
export const milliToHHMMSS = (millis) => {
    let seconds = millis / 1000 + (millis % 1000 > 0 ? 1 : 0);
    let hours = Math.floor(seconds / 3600).toString();
    let minutes = Math.floor((seconds % 3600) / 60).toString();
    seconds = Math.floor(seconds % 60).toString();

    return [hours.padStart(2, '0'), minutes.padStart(2, '0'), seconds.padStart(2, '0')].join(':');
}